import { Component, OnInit } from "@angular/core";
import { interval, Subscription } from "rxjs";
import { LogListWrapper } from "src/app/core/models/healthLogList";
import { HealthService } from "src/app/core/services/health.service";
import { SyncConfigService } from "src/app/core/services/sync-config.service";

@Component({
  selector: "app-health-logs",
  standalone: false,
  templateUrl: "./health-logs.component.html",
  styleUrl: "./health-logs.component.scss",
})
export class HealthLogsComponent implements OnInit {
  constructor(
    private healthService: HealthService,
    public syncConfig: SyncConfigService
  ) {}
  hostLoglist: LogListWrapper;
  dataReloadSubscription: Subscription;
  ngOnInit(): void {
    this.getHostLogList();
    this.startDataReloadSub();
  }

  getHostLogList() {
    this.healthService.getHostLogList().subscribe({
      next: (data: any) => {
        this.hostLoglist = <LogListWrapper>JSON.parse(JSON.stringify(data));
      },
      error: (err) => {
        console.error(err);
      },
    });
  }

  startDataReloadSub() {
    this.dataReloadSubscription = interval(
      this.syncConfig.config.healthService.dataReqInterval
    ).subscribe(async () => {
      await this.getHostLogList();
    });
  }
}
